export default "__VITE_ASSET__DoCU7jfi__"